// 必要なモジュールやコンポーネントをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用共通フレーム
import { Box, Button, Card, CardActionArea, CardActions, CardContent, Container, Paper, Typography } from "@mui/material"; // Material-UIコンポーネント
import { styled } from '@mui/material/styles'; // Material-UIのスタイリング
import { Link, useNavigate } from "react-router-dom"; // React Routerのリンクとナビゲーション

/** Entry Home テンプレート */
const EntryHomeTemplate = () => {
    const navigate = useNavigate(); // ページ遷移用の関数

    // 表示する項目の設定
    const itemNumber: number[] = [1, 2]; // 各教材の識別番号
    const buttonTitle: string[][] = [
        ["", "", "Linuxコマンド入門", "", ""], // ボタンに表示するタイトルリスト
        ["", "", "認知特性テスト", "", ""] // 新しい項目を追加
    ];

    // 各ボタンに対応するページのパスを設定
    const pagePaths: string[] = [
        "/entry/material?no=1", // Linuxコマンド入門のページ
        "/entry/material?no=2" // 認知特性テストの新しいページ
    ];

    // スタイリングされたMaterial-UIのPaperコンポーネント
    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 75,
        lineHeight: '13px',
    }));

    return (
        // ユーザー用共通フレームを使用（新入社員向けのページとして表示）
        <UserFrame title='新入社員向け' isEntry>
            <Container>
                {/* ボタンリストのコンテンツ */}
                <Box marginTop={"5rem"}>
                    {/* 各教材ボタンをループで生成 */}
                    {buttonTitle.map((text, index) => (
                      <Card sx={{ minWidth: 275, margin: '3px 0' }} key={index}>
                        {/* ボタン全体をクリック可能にする */}
                        <CardActionArea onClick={() => { 
                            navigate(pagePaths[index]); // 各ボタンに対応するページに遷移
                        }}>
                          <CardContent sx={{ textAlign: 'center' }}>
                            {/* ボタンのタイトルを表示 */}
                            <Typography variant="h6" component="div">
                              {text[2]}
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    ))}
                </Box>
            </Container>
        </UserFrame>
    );
}

export default EntryHomeTemplate;
